angular.module('workflow')
    .controller('WorkflowAddTouchOnlyController', function ($scope, $rootScope, $uibModalInstance, data, Workflow) {
        this.$onInit = () => {
            this.form = {
                id: data,
                worker: null
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return Workflow.addTouchOnly(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast("workflow.updated")
                })
        }
    })
